export class HistoryEvent<A> {
  private prevented = false
  readonly action: A
  readonly signal: AbortSignal

  get isPrevented() {
    return this.prevented
  }

  preventDefault() {
    this.prevented = true
  }

  constructor({ action, signal }: { action: A; signal: AbortSignal }) {
    this.action = action
    this.signal = signal
  }
}
